export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function nearestMillion(x) {
  const nearestMil = Math.round(x / 1000000) * 1000000
  return nearestMil
}
